























import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class SlcShortcuts extends Vue {
  @Prop() items: any[];
}
